import {css} from "lit-element/lit-element.js";
export default css`
:root {
  --text-bg: hsl(0, 0%, 97%);
  --gray-border: hsla(0, 0%, 0%, 0.1);
  --gray: rgba(0, 0, 0, 0.6);
  --border-radius: 5px;
  --orange: hsl(24, 100%, 50%);
  --distill-blue: hsl(200, 50%, 25%);
  --blue: #337699;
  --green: #3db867;
  --text-fg: rgb(15, 15, 15);
  --text-red: rgb(220, 0, 0);
  --bar-col: rgb(171, 199, 227);
  --link-col: rgb(0, 0, 238);
  --placeholder-col: rgb(166, 166, 166);
  --note-bg: #e1f5fe;
  --note-fg: #1a6ebb;
  --warn-bg: #ffe1aa;
  --warn-fg: #a16800;
  --error-bg: #850000;
  --error-fg: white;
}
@media (prefers-color-scheme: dark) {
  :root {
    --text-bg: rgb(56, 56, 56);
    --text-fg: rgb(213, 213, 213);
    --bar-col: rgb(20, 109, 163);
    --link-col: rgb(66, 165, 245);
    --note-fg: rgb(121 157 190);
    --note-bg: rgb(2 59 85);
    --warn-bg: #784e00;
    --warn-fg: #edbe68;
  }
}

.lds-ellipsis {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.lds-ellipsis div {
  position: absolute;
  top: 33px;
  width: 13px;
  height: 13px;
  border-radius: 50%;
  background: var(--text-fg);
  animation-timing-function: cubic-bezier(0, 1, 1, 0);
}
.lds-ellipsis div:nth-child(1) {
  left: 8px;
  animation: lds-ellipsis1 0.6s infinite;
}
.lds-ellipsis div:nth-child(2) {
  left: 8px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(3) {
  left: 32px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(4) {
  left: 56px;
  animation: lds-ellipsis3 0.6s infinite;
}

@keyframes lds-ellipsis1 {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes lds-ellipsis3 {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
}
@keyframes lds-ellipsis2 {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(24px, 0);
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
